import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { db } from "@/modules/shared/lib/db-client";
import { Loader2 } from "lucide-react";

export function AllocationRedirect() {
  const { id } = useParams();
  const [professionalId, setProfessionalId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function lookup() {
      const { data } = await db
        .from("allocations")
        .select("professional_id")
        .eq("id", id)
        .maybeSingle();
      setProfessionalId(data?.professional_id || null);
      setLoading(false);
    }
    lookup();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-[var(--ink)]" />
      </div>
    );
  }

  if (professionalId) {
    return <Navigate to={`/profissionais/${professionalId}`} replace />;
  }

  return <Navigate to="/profissionais?tab=alocacoes" replace />;
}
